import './thumbnail-slider.scss';
import 'slick-carousel';
export default (() => {
  $('.js-thumbnail-slider').slick({
    rows: 0,
    infinite: true,
    slidesToShow: 4,
    prevArrow: '.js-thumbnail-prev',
    nextArrow: '.js-thumbnail-next',
    autoplay: true,
    arrows: true,
    responsive: [{
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 768,
      settings: {
        infinite: true,
        slidesToShow: 1
      }
    }]
  });
});